module.exports = __webpack_public_path__ + "img/match--type1_img1.44211430.png";